import { render, staticRenderFns } from "./EmailContactDialog.vue?vue&type=template&id=32cae53e&scoped=true&lang=html&"
import script from "./EmailContactDialog.vue?vue&type=script&lang=js&"
export * from "./EmailContactDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cae53e",
  null
  
)

export default component.exports